
    const data = {"name":"src/core/icons/arrow-split-vertical","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M18 16v-3h-3v9h-2V2h2v9h3V8l4 4-4 4M2 12l4 4v-3h3v9h2V2H9v9H6V8l-4 4Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            